"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.importAccountingDoctolibCsvDazzApiResponseSchema = exports.dazzManualReviewItemResponseSchema = exports.importAccountingDoctolibCsvDazzManualResolutionSchema = void 0;
const zod_1 = require("zod");
const event_schema_1 = require("../global/event.schema");
exports.importAccountingDoctolibCsvDazzManualResolutionSchema = zod_1.z.object({
    invoiceIdentifier: zod_1.z.string(),
    halfDay: zod_1.z.enum(event_schema_1.periodsOfTheDayWithoutAllday),
});
exports.dazzManualReviewItemResponseSchema = zod_1.z.object({
    invoiceIdentifier: zod_1.z.string(),
    beneficiary: zod_1.z.string(),
    date: zod_1.z.string(),
    totalAmountDue: zod_1.z.number(),
    totalAmountPaid: zod_1.z.number(),
    slotsThatDay: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.string(),
        periodOfTheDay: zod_1.z.enum(event_schema_1.periodsOfTheDay),
        startAt: zod_1.z.string(),
        endAt: zod_1.z.string(),
        doctorSubstituteId: zod_1.z.string().nullable(),
    })),
    attendingHasWorkScheduleThatDay: zod_1.z.boolean(),
});
exports.importAccountingDoctolibCsvDazzApiResponseSchema = zod_1.z.discriminatedUnion('status', [
    zod_1.z.object({ status: zod_1.z.literal('success') }),
    zod_1.z.object({
        status: zod_1.z.literal('needs_manual_review'),
        items: zod_1.z.array(exports.dazzManualReviewItemResponseSchema),
    }),
]);
